export default "__VITE_ASSET__D9615gM0__"